module.exports = __webpack_public_path__ + "img/ca.f712c9ff.svg";